import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/**
 * Android has a hardware/gesture back button with no web equivalent; without
 * this it does nothing (Capacitor does not wire it to browser history for
 * you) and the app looks frozen. `canGoBack` already reflects the SPA's own
 * history stack, since React Router's `BrowserRouter` uses the same
 * `pushState` this plugin watches, so this needs no route-specific logic:
 * back button behaves like the browser back button, and exits at the root.
 */
export function installNativeBackButton(): void {
  if (!Capacitor.isNativePlatform()) return;
  void App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      void App.exitApp();
    }
  });
}
